import React, {Component} from 'react'
import * as Styles from './index.module.css'

class EmphasizeText extends Component {

    handleTextReplace = (text, keywords) => {
        if (!keywords) {
            return text;
        }
        keywords = Array.isArray(keywords) ? keywords : [keywords];
        let result = text;
        keywords.forEach((k) => {
            result = result ? result.replace(new RegExp(k.keyword, 'g'), `<span style="color:${k.color}">${k.keyword}</span>`) : result
        });
        return result
    }

    render() {
        const keywords = this.props.keywords;
        const color = this.props.color;
        let text = this.props.children;
        const html = this.handleTextReplace(text, keywords);
        return (
            < span
                dangerouslySetInnerHTML={
                    {
                        __html: html
                    }
                }
            />
        );
    }
}

export default EmphasizeText